'use strict'
var _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault')
exports.__esModule = true
exports.default = void 0

var _Adapter = _interopRequireDefault(require('./Adapter'))
var _AdapterWithEvents = _interopRequireDefault(require('./AdapterWithEvents'))
var _StoragesCollection = _interopRequireDefault(require('./StoragesCollection'))

var _funcs = require('./funcs')
var Storages = /*#__PURE__*/ (function() {
  function Storages() {}
  Storages.createAdapter = function createAdapter(arg) {
    return new _Adapter.default(arg)
  }
  Storages.createAdapterWithEvents = function createAdapterWithEvents(arg) {
    return new _AdapterWithEvents.default(arg)
  }
  Storages.createStoragesCollection = function createStoragesCollection() {
    return new _StoragesCollection.default()
  }
  Storages.getItem = function getItem(name, type) {
    return (0, _funcs.getItem)(name, type)
  }
  Storages.setItem = function setItem(name, value, type) {
    return (0, _funcs.setItem)(name, value, type)
  }
  Storages.removeItem = function removeItem(name, type) {
    return (0, _funcs.removeItem)(name, type)
  }
  Storages.getNativeType = function getNativeType(maybeType) {
    return (0, _funcs.getNativeType)(maybeType)
  }
  Storages.toPrivateName = function toPrivateName(name) {
    return (0, _funcs.toPrivateName)(name)
  }
  return Storages
})()
exports.default = Storages



//////////////////
// WEBPACK FOOTER
// ./~/hlp/dist/Storages/index.js
// module id = 618
// module chunks = 0